import React, { useState } from 'react'
import {
  PlaybookViewContext,
  PlaybookViewContextType,
} from '../contexts/playbookViewContext'

type PlaybookViewProviderProps = {
  children: (contextValue: PlaybookViewContextType) => React.ReactNode
  initialIsShown?: boolean
}

export const PlaybookViewProvider: React.FC<PlaybookViewProviderProps> = ({
  children,
  initialIsShown = false,
}) => {
  const [isShown, setIsShown] = useState(initialIsShown)

  const toggle = () => {
    setIsShown((prev) => !prev)
  }

  const contextValue: PlaybookViewContextType = {
    isShown,
    toggle,
  }

  return (
    <PlaybookViewContext.Provider value={contextValue}>
      {children(contextValue)}
    </PlaybookViewContext.Provider>
  )
}
